import { colors } from '@scouts/ui'

import { TaxRegistrationStatusOrder } from '@/models'

import config from '../config'
import {
    QUARTERLY_TAX_RETURN_STATUS_ORDER,
    QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARIES_STATUS_ORDER,
    SECTION_STATUS_ORDER,
    SUBSCRIPTION_STATUS_ACTIVE,
    SUBSCRIPTION_STATUS_CANCELLED,
    TAX_RETURN_STATUS_ORDER,
} from '../constants'

export { copyTextToClipboard } from './clipboard'
export {
    formatDate,
    formatDateDayAndMonth,
    formatDateLong,
    formatDateWithTime,
    formatTaxYearDateRange,
    getIsWeekend,
} from './dates'
export { removeItemsById, syncSlice, updateOrAddItemsById, updateOrAddItemById } from './redux'
export { formatAlphaNumericalUppercase, formatCurrency, hexToRgbA } from './strings'

export const downloadFileByUrl = (url) => {
    const anchor = document.createElement('a')
    anchor.id = url
    anchor.href = url
    anchor.download = true
    const mouseEvent = new MouseEvent('click', {
        view: window,
        bubbles: false,
        cancelable: false,
    })
    document.body.appendChild(anchor)
    anchor.dispatchEvent(mouseEvent)
    document.body.removeChild(anchor)
}

const openWindow =
    (options = { target: '_blank', windowFeatures: 'noopener noreferrer' }) =>
    (url) =>
        window.open(url, options.target, options.windowFeatures)

export const navigateOutside = openWindow()

export const navigateToWhatsApp = () => {
    navigateOutside(config.whatsappUrl)
}

export const isTaxReturnStatusAtLeast = (current, target) =>
    TAX_RETURN_STATUS_ORDER[current] >= TAX_RETURN_STATUS_ORDER[target]

export const isQuarterlyTaxReturnsStatusAtLeast = (current, target) =>
    QUARTERLY_TAX_RETURN_STATUS_ORDER[current] >= QUARTERLY_TAX_RETURN_STATUS_ORDER[target]

export const isQuarterlyTaxReturnsStatusBetween = (current, start, end) =>
    QUARTERLY_TAX_RETURN_STATUS_ORDER[current] >= QUARTERLY_TAX_RETURN_STATUS_ORDER[start] &&
    QUARTERLY_TAX_RETURN_STATUS_ORDER[current] <= QUARTERLY_TAX_RETURN_STATUS_ORDER[end]

export const isTaxRegistrationStatusAtLeast = (current, target) =>
    TaxRegistrationStatusOrder[current] >= TaxRegistrationStatusOrder[target]

export const isQuarterlyTaxReturnsAnnualSummaryStatusAtLeast = (current, target) =>
    QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARIES_STATUS_ORDER[current] >=
    QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARIES_STATUS_ORDER[target]

export const isSectionStatusAtLeast = (current, target) => SECTION_STATUS_ORDER[current] >= SECTION_STATUS_ORDER[target]

export const convertStringToBoolean = (v) => {
    if (v === 'true') return true
    if (v === 'false') return false
    return v
}

export const uploadFilterPattern = (upload) => {
    const {
        employmentId,
        fileSubType,
        fileType,
        filingArea,
        taxReturnId,
        quarterlyTaxReturnId,
        isFileSubTypeRequired = true,
    } = upload

    const pattern = {
        ...(quarterlyTaxReturnId && { quarterlyTaxReturnId }),
        ...(taxReturnId && { taxReturnId }),
        ...(employmentId && { employmentId }),
        ...(filingArea && { filingArea }),
        ...(fileType && { fileType }),
    }

    if (isFileSubTypeRequired) {
        pattern.fileSubType = fileSubType || null
    }

    return pattern
}

export const getSubscriptionBackgroundFromStatus = (status) => {
    switch (status) {
        case SUBSCRIPTION_STATUS_ACTIVE:
            return colors.surface.affirm
        case SUBSCRIPTION_STATUS_CANCELLED:
            return colors.surface.note
        default:
            return colors.surface.attention
    }
}

export const round = (number) => Math.round(number)

export const callAll =
    (...fns) =>
    (...args) => {
        fns.forEach((fn) => typeof fn === 'function' && fn(...args))
    }

export const filterConsecutiveDuplicates = (item, i, array) => i === 0 || item !== array[i - 1]
